import { getSiteUrl } from './config';

/** @typedef {'team' | 'marketplace'} PasswordResetScope */

export const PASSWORD_RESET_SCOPES = {
  team: {
    label: 'organisation transport',
    loginPath: '/login',
    forgotPath: '/forgot-password?scope=team',
  },
  marketplace: {
    label: 'driver booking',
    loginPath: '/marketplace/login',
    forgotPath: '/forgot-password?scope=marketplace',
  },
};

/**
 * @param {string | null | undefined} raw
 * @returns {PasswordResetScope}
 */
export function parsePasswordResetScope(raw) {
  return raw === 'marketplace' ? 'marketplace' : 'team';
}

/**
 * Redirect URL for Supabase reset email (must be allowlisted in Supabase Auth settings).
 * Path-based scope avoids query-string mismatches in Supabase redirect allowlists.
 * @param {PasswordResetScope} scope
 */
export function passwordResetRedirectUrl(scope) {
  // Prefer the live browser origin so reset links match where the user is browsing.
  const runtimeOrigin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin.replace(/\/$/, '')
      : '';
  const origin = runtimeOrigin || getSiteUrl();
  return origin ? `${origin}/reset-password/${scope}` : '';
}

/** True while the user is on the password reset page (recovery flow). */
export function isPasswordResetPage() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/reset-password');
}

/** Supabase recovery links arrive as hash tokens or PKCE query params — still processing. */
export function hasRecoveryTokenInUrl() {
  if (typeof window === 'undefined') return false;
  const hash = window.location.hash || '';
  const search = window.location.search || '';
  if (hash.includes('access_token') || hash.includes('type=recovery')) return true;
  if (search.includes('code=') || search.includes('token_hash=')) return true;
  return false;
}
